export default __webpack_public_path__ + "static/media/mask.ba29dae1.svg";